module.exports = __webpack_public_path__ + "static/img/step2_4.177e4aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/step2_4.png
// module id = 2x8p
// module chunks = 1